import React from 'react';
const ModelTitle = props => {
    return (React.createElement("h2", { className: "c_modal-title" }, props.title));
};
export default ModelTitle;
